import { ChevronUp } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { SearchKeywords } from "./SearchKeywords";

const QUALITY = [{ value: 0, label: "Tutti" }, { value: 2, label: "★★+" }, { value: 3, label: "★★★+" }];

export const SearchFilterBar = ({ selectedZone, keywords, minimumRating, onOpen }) =>
  <button type="button" className="search-filter-bar" onClick={onOpen} data-testid="search-filter-open">
    <span className="search-step-index" data-testid="search-filter-step">2/2</span>
    <span className="search-filter-summary"><strong data-testid="search-filter-zone">{selectedZone?.name || "Tocca una zona sulla mappa"}</strong>
      <small data-testid="search-filter-selection">{keywords.length ? `${keywords.length} attività` : "Scegli attività"} · {minimumRating ? `★${minimumRating}+` : "tutti i voti"}</small></span>
    <ChevronUp size={18} aria-hidden="true" />
  </button>;

export const SearchFiltersSheet = ({ open, onClose, groups, keywords, onKeywords, minimumRating,
                                     onRating, areaLabel, coverage, manager, onEnrich, onBack, onSearch, searching }) =>
  <Sheet open={open} onOpenChange={(next) => { if (!next) onClose(); }}>
    <SheetContent side="bottom" className="hud-sheet search-filters-sheet" closeTestId="search-filters-close-button"
      data-testid="search-filters-sheet" description="Scegli attività e qualità; tocca una zona sulla mappa.">
      <div className="sheet-grab" aria-hidden="true" />
      <SheetHeader><SheetTitle className="sheet-title" data-testid="search-filters-title">2 / 2 · FILTRI</SheetTitle></SheetHeader>
      <SearchKeywords groups={groups} selected={keywords} onChange={onKeywords} />
      <div className="filter-quality"><span className="section-label">QUALITÀ</span>
        <div className="quality-segments" role="group" aria-label="Qualità dei locali" data-testid="search-quality">
          {QUALITY.map((option) => <button type="button" key={option.value} className={minimumRating === option.value ? "active" : ""}
            aria-pressed={minimumRating === option.value} onClick={() => onRating(option.value)} data-testid={`quality-${option.value}`}>{option.label}</button>)}
        </div>
      </div>
      <p className="filter-zone-info" data-testid="search-selected-zone">Area · {areaLabel}</p>
      {manager && coverage > 0 && <button type="button" className="text-action" onClick={onEnrich}
        data-testid="map-geocode-button">Recupera coordinate mancanti ({coverage})</button>}
      <div className="search-filter-actions"><button type="button" className="hud-button hud-secondary" onClick={onBack}
        data-testid="filters-back-to-area">‹ Area</button>
        <button type="button" className="hud-button search-filters-done" disabled={!keywords.length || searching}
          onClick={onSearch} data-testid="search-filters-launch">Lancia ricerca</button></div>
    </SheetContent>
  </Sheet>;